export const CUSTOMERADMIN = "CUSTOMERADMIN";
export const DASHBOARDADMIN = "DASHBOARDADMIN";
export const REPORTADMIN = "REPORTADMIN";

export const DASHBOARD_ROLES = ['CUSTOMERADMIN', 'DASHBOARDADMIN'];
export const REPORT_ROLES = ['CUSTOMERADMIN', 'REPORTADMIN'];


export const RolesfromToken = (token) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    const json = JSON.parse(window.atob(base64));
    return json.role;
}


// WEBPACK FOOTER //
// ./src/authorization/roles.js